import { useState, useEffect } from 'react'
import { X } from 'lucide-react'
import { cn } from '@/utils/cn'

export function Modal({ 
  open = false, 
  onOpenChange, 
  children, 
  className = '',
  ...props 
}) {
  const [isOpen, setIsOpen] = useState(open)

  useEffect(() => {
    setIsOpen(open)
  }, [open])

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }

    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  const handleClose = () => {
    setIsOpen(false)
    onOpenChange?.(false)
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50"
        onClick={handleClose}
      />
      
      {/* Modal */}
      <div 
        className={cn(
          'relative bg-background rounded-2xl shadow-lg max-w-lg w-full mx-4 max-h-[90vh] overflow-auto',
          className
        )}
        {...props}
      >
        {children}
      </div>
    </div>
  )
}

export function ModalHeader({ children, className = '', showClose = true, onClose }) {
  return (
    <div className={cn('flex items-center justify-between p-6 border-b', className)}>
      <div className="flex-1">
        {children}
      </div>
      {showClose && (
        <button
          onClick={onClose}
          className="p-1 hover:bg-accent rounded-lg transition-colors"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  )
}

export function ModalTitle({ children, className = '' }) {
  return (
    <h2 className={cn('text-lg font-semibold', className)}>
      {children}
    </h2>
  )
}

export function ModalContent({ children, className = '' }) {
  return (
    <div className={cn('p-6', className)}>
      {children}
    </div>
  )
}

export function ModalFooter({ children, className = '' }) {
  return (
    <div className={cn('flex items-center justify-end gap-3 p-6 border-t', className)}>
      {children}
    </div>
  )
}